import React from "react";
import { ColorRing } from "react-loader-spinner";
import styles from "./button.module.scss";
import { motion } from "framer-motion";
const Button = ({
  buttonText,
  icon,
  image,
  iconText,
  imageClassName = "",
  onClick,
  overrideClassName,
  loading,
  disabled,
  onMouseEnter,
  loaderSize = 30,
  ...props
}) => {
  return (
    <motion.button
      disabled={disabled}
      whileHover={disabled ? {} : { scale: 1.02 }}
      whileTap={disabled ? {} : { scale: 0.98 }}
      className={`${styles.button} ${overrideClassName}`}
      onClick={(e) => !disabled && onClick && onClick(e)}
      onMouseEnter={onMouseEnter}
      {...props}
    >
      {icon && icon}
      {image && <img src={image} alt="icon" className={imageClassName} />}
      {iconText && <span>{iconText}</span>}
      {loading ? (
        <ColorRing
          visible={true}
          height={loaderSize}
          width={loaderSize}
          ariaLabel="blocks-loading"
          wrapperStyle={{}}
          wrapperClass="blocks-wrapper"
          colors={["#f0b23c", "#ff9933", "#f0b23c", "#ff9933", "#f0b23c"]}
        />
      ) : (
        <span style={{ marginLeft: icon || image ? 5 : 0 }}>{buttonText}</span>
      )}
    </motion.button>
  );
};

export default Button;
